// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw Online Screen Recorder',
  RecordScreenWithAudio:
    'Record entire screen, an application window, or browser tab with audio',
  ScreenOnly: 'Screen Only',
  ScreenAndCam: 'Screen & Webcam',
  Microphone: 'Microphone',
  SystemAudio: 'System Audio',
  StartRecording: 'Start Recording',
  NoAudioAndTryAgain:
    'No audio source available. Please follow <1><0>the instructions</0></1> below and try again.',
  TheInstruction: 'the instructions',
  AccessMicrophone:
    'online.hitpaw.com need to access your Microphone to record audio, please click Allow!',
  BestScreenRecorderSoftware:
    'Best Screen Recorder & Free Video Streaming Software',
  CaptureAnythingOnScreen:
    'Capture and record your websites, lectures, video calls, and anything on screen',
  RecordToShare: 'Record your gameplay highlights to share with friends',
  StreamOnFackbook: 'Stream on Facebook, YouTube, Twitch, etc. like a pro',
  BringMagic: 'Bring magic virtual webcam to live streams and video chats',
  StepOne: 'Step1: Choose the screen you want to record.',
  StepTwo: 'Step2: Choose the screen you want to record.',
  StepThree: 'Step3: Click“Share system audio”.',
  StepFour: 'Step2: Click “Share”and start recording.',
  GrantPermission:
    'Please grant permission for screen recording and try again.',
  RecordingProgress: 'Recording in progress...',
  MoreOptions: 'More Recording Options:',
  Pause: 'Pause',
  Continue: 'Continue',
  Stop: 'Stop',
  Webcam: 'Webcam',
  GreenScreenAndChangeBackground: 'Green Screen & Change Background',
  StreamToYouTube: 'Stream to Facebook, Twitch, YouTube, etc.',
  ScheduleRecording: 'Schedule Recording',
  NewRecording: 'New Recording',
  ExportToMp4: 'Export to MP4',
  AddWatermark: 'Add Watermark',
  ChangeSpeed: 'Change Speed',
  CutAndTrim: 'Cut & Trim',
  '120XDownload': '120X Faster Video Converter & HD Video Downloader',
  CovertAudioFormats: 'Convert video and audio files to 1000+ formats',
  DownloadVideoFromWebsites:
    'Download and save videos from 10000+ video sharing websites',
  BatchConvertImageAndGif: 'Batch convert images and create GIFs from videos',
  RichEdingingFeatures:
    'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  BestVideoEditor: 'Best Video Editor Designed for Multi-Purposes',
  MakeSimpleEdits:
    'An award-winning video editor to make complex edits simple.',
  BeyondImaginationMaterials:
    'Varous built-in and online materials beyond imagination.',
  AqualityVideoMaker:
    'A quality-oriented video maker to export and share 1080P/4K videos completely free.',
  WorkOnAnywhere:
    'Works well and safely on any PC without affecting its performance.',
  RecordCompleted: 'Recording Completed',
  Download: 'Download',
  YouMayNeed: 'You May Need',
  TryItFree: 'Try It Free',
  AlreadyHaveAccount: 'уже есть счёт?',
  LoginNow: 'Войти сейчас',
  exceedTenMin: 'Время истекло для 10-минутной записи.',
  UpgradeToRecord: 'Обновление, чтобы продолжить запись.',
  ScreenProFeature:
    'Обновите, чтобы получить доступ к HitPaw Online Screen Recorder Pro.',
  FreeScreenAccount:
    'Бесплатная учетная запись имеет всего <1><0>10</0></1> минут времени записи.',
  BuyNow: 'КУПИТЬ СЕЙЧАС',
  DownloadMp4: 'Скачать (видео) в формате MP4',
  FreeDownload: 'Скачать бесплатно',

  DownloadTenMin: 'Скачать 10 минут',
  FullVideo: 'Полная длина',
  FormatMp4: 'Формат MP4',
  Downloading: 'Загрузка ...',
  DownloadFailed: 'Не удалось скачать, попробуйте еще раз.',
  DownloadSuccess: 'Скачать успешно!',
  Exceed100MDownloadConvert:
    'Размер видео не может превышать 100 МБ для загрузки видео в формате MP4. Скачать HitPaw Video Converter для получения дополнительных функций.',
  Exceed30Min:
    'Продолжительность видео не может превышать 30 минут для загрузки видео в формате MP4. Скачать HitPaw Video Converter для получения дополнительных функций.',
  Week: 'Еженедельно',
  Month: 'Ежемесячно',
  Year: 'Ежегодно',
  BilledMonthly: 'долл. США ежемесячно',
  BilledAnnually: 'долл. США ежегодно',
  ConvertText1:
    'Скачать версию рабочего стола в процесс партии больших файлов без ограничения размера',
  ConvertText2:
    'Пакетный конверт видео и аудиофайлы в 1000+ форматов с более высокой скоростью в 120 раз',
  ConvertText3:
    'Скачать и сохранить видео с сайтов 10000+, таких как YouTube, Tiktok, Instagram и т. Д.',
  ConvertText4:
    'Конвертировать Apple Music в MP3 с удаленным DRM (только версия Windows)',
  TenMinUp: 'A gravação já atingiu 10 minutos.',
  UpgradeMore: 'Atualizar para continuar a gravação..',
  NoRecordLimit: 'Gravação de vídeo sem limite de tempo',
  NoRecordNumLimit: 'Gravação de vídeo sem limitação de número',
  DownloadVideoMP4: 'Скачать видео как mp4',
  MonthOff: 'скидка 60%',
  YearOff: 'скидка 80%',
  UpgradeNow: 'Немедленное повышение',
  CheckConnect: 'Пожалуйста, проверьте соединение и попробуйте снова.',
};
